var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgGeofence = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Geofence",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_pin_drop_24px",
    className: "cls-2",
    d: "M16.383,7.254a5.254,5.254,0,1,0-10.507,0c0,3.94,5.254,9.632,5.254,9.632S16.383,11.194,16.383,7.254Zm-7,0A1.751,1.751,0,1,1,11.129,9,1.756,1.756,0,0,1,9.378,7.254ZM5,17.761v1.751H17.258V17.761Z",
    transform: "translate(-1.448 -1.127)",
    fill: "#FFFFFF"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGeofence, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Geofence.e481d97c.svg";
export { ForwardRef as ReactComponent };